import KnBackToTopButton from '../../../shared/components/KnBackToTopButton.vue';
import KnDocItem from '../../../shared/components/KnDocItem.vue';
import KnFormNoteOfMandatory from '../../../shared/components/KnFormNoteOfMandatory.vue';
import KnFormTitle from '../../../shared/components/KnFormTitle.vue';
import KnImageDocItem from '../../../shared/components/KnImageDocItem.vue';
import KnLocalAlert from '../../../shared/components/KnLocalAlert.vue';
import KnTabs from '../../../shared/components/KnTabs.vue';
import KnFormSubtitle from '../../../shared/components/KnFormSubtitle/KnFormSubtitle.vue';
import KnFormActionButtons from '../../../shared/components/KnFormActionButtons/KnFormActionButtons.vue';
import KnTextField from '../../../shared/components/KnTextField.vue';
import KnAutoComplete from '../../../shared/components/KnAutoComplete.vue';
import KnCheckBox from '../../../shared/components/KnCheckBox.vue';
import KnSubjectsAutocomplete from '../KnSubjectsAutocomplete/KnSubjectsAutocomplete.vue';
import KnPagination from '../../../shared/components/KnPagination.vue';
import { getFullName } from '../../../shared/helpers/dataUtils';
import { validationFormMixin } from '../../../shared/mixins/validationFormMixin';

import {
  fetchClassroom,
  fetchGroupSucursals,
  fetchSchoolCycles,
} from '../../../configuration/helpers/KnGroupsOptions';
import {
  fetchSchoolLevels,
  fetchSubjects,
  fetchSyllabus,
} from '../../helpers/syllabusOptions';
import { fetchTypesEmployee } from '../../../configuration/helpers/KnEmployeeTypesOptions';
import {
  fetchEmployee,
  fetchEmployeeByName,
  // postCreateSpecialGroup,
} from '../../helpers/employeeOptions';
import { fetchStudents } from '../../helpers/reportCardOptions';
import { paginationMixin } from '../../../shared/mixins/paginationMixin';
import { fetchStudentByName } from '../../../students/helpers/utilsStudent';
// import {
//   fetchSubjectTeacher,
//   putGroup,
//   putSubjectTeacher,
// } from '../../helpers/subjectsTeacherOptions';
import { mapGetters, mapState } from 'vuex';
import {
  createSubjectTeacher,
  postGroup,
} from '../../helpers/subjectsTeacherOptions';
import { postAssignStudentsToGroup } from '../../helpers/actionsGroupsOptions';

export default {
  name: 'KnFormGroups',
  components: {
    KnAutoComplete,
    KnBackToTopButton,
    KnCheckBox,
    KnDocItem,
    KnFormActionButtons,
    KnFormNoteOfMandatory,
    KnFormSubtitle,
    KnFormTitle,
    KnImageDocItem,
    KnLocalAlert,
    KnPagination,
    KnSubjectsAutocomplete,
    KnTabs,
    KnTextField,
  },
  mixins: [paginationMixin, validationFormMixin],
  props: {
    entity: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      tabs: [
        { name: 'Datos del grupo', value: 33 },
        { name: 'Asignación de profesores', value: 66 },
        { name: 'Asignación de alumnos', value: 100 },
      ],
      valueDeterminate: 33,
      routerName: 'Grupos',
      resource: 'grupo',
      bkEntity: null,
      bkReadonly: false,
      groupId: null,
      groupImage: null,
      group: {
        nombre_grupo: '',
        sucursal: null,
        salon_clases: null,
        profesores: [],
        materia_profesor: [],
        alumnos: [],
        imagen_grupo: null,
        ciclo_escolar: null,
        duracion_ciclo_escolar_meses: null,
        institucion_educativa: null,
        plan_estudios: null,
        nivel_educativo: null,
        estatus_sistema: true,
      },
      studentDetail: {},
      availableSubjects: [],
      selectedSubjects: [],
      selectedTeacher: null,
      subjectTeacherData: [],
      createdSubjectsTeacher: [],
      cycles: [],
      levels: [],
      syllabus: [],
      groups: [],
      teachers: [],
      subjects: [],
      students: [],
      branches: [],
      classrooms: [],
      selectedStudents: [],
      loadingGroups: false,
      loadingEmployees: false,
      loadingStudents: false,
      teacherType: null,
      inputSubject: null,
      inputTeacher: null,
      inputStudent: null,
      /** Variables para alerta */
      errors: [],
      warnings: [],
      loading: false,
      showAlert: false,
      alertType: 'success',
      alertText: 'Registro exitoso',
      alertColor: null,
      /*********************** */
      syllabusMessage: [],
      teacherPagination: {},
      assignTeacher: false,
      assignStudents: false,
    };
  },
  computed: {
    ...mapState(['institutionId', 'userData']),
    ...mapGetters(['currentSchoolYear', 'currentSchoolLevel']),
    dynamicTabs() {
      return this.assignTeacher && this.assignStudents
        ? [
            { name: 'Datos del grupo', value: 33 },
            { name: 'Asignación de profesores', value: 66 },
            { name: 'Asignación de alumnos', value: 100 },
          ]
        : this.assignTeacher && !this.assignStudents
        ? [
            { name: 'Datos del grupo', value: 33 },
            { name: 'Asignación de profesores', value: 66 },
          ]
        : !this.assignTeacher && this.assignStudents
        ? [
            { name: 'Datos del grupo', value: 33 },
            { name: 'Asignación de alumnos', value: 100 },
          ]
        : [{ name: 'Datos del grupo', value: 33 }];
    },
    isNewMode() {
      return this.entity === null || this.bkEntity === null;
    },
    title() {
      return this.isNewMode ? 'Agregar grupo oficial' : 'Editar grupo oficial';
    },
    isReadonly() {
      return this.readonly || this.bkReadonly;
    },
    successAlertText() {
      return this.isNewMode
        ? 'Grupo oficial creado exitosamente!'
        : 'Grupo oficial actualizado exitosamente!';
    },
    successAlertType() {
      return this.isNewMode ? 'success' : 'info';
    },
    warningText() {
      return this.warnings.length ? this.warnings.join(',') : null;
    },
    filteredAvailableStudents() {
      return this.students.filter(
        (aStudent) =>
          !this.selectedStudents
            .map((sStudent) => sStudent.id)
            .includes(aStudent.id)
      );
      // return this.students.filter(aStudent => !this.selectedStudents.some(sStudent => sStudent.id === aStudent.id))
    },
    filteredSubjects() {
      return this.subjectTeacherData.length
        ? this.subjects.filter(
            (subject) =>
              !this.subjectTeacherData.some((st) =>
                st.subjects.map((s) => s.id).includes(subject.id)
              )
          )
        : this.subjects;
    },
    selectedSyllabusObj() {
      return this.group.plan_estudios
        ? this.syllabus.find((s) => s.id === this.group.plan_estudios)
        : null;
    },
    selectedTeacherObj() {
      return this.selectedTeacher
        ? this.teachers.find((t) => t.id === this.selectedTeacher)
        : null;
    },
    selectedSubjectsObj() {
      return this.selectedSubjects.length
        ? this.subjects.filter((s) => this.selectedSubjects.includes(s.id))
        : [];
    },
    selectedSchoolLevelName() {
      let schoolLevelName = null;
      if (this.group.nivel_educativo) {
        const findedLevel = this.levels.find(
          (l) => l.id === this.group.nivel_educativo
        );
        if (findedLevel) {
          schoolLevelName = findedLevel.nombre;
        }
      } else {
        this.students = [];
        this.assignStudents = false;
      }
      return schoolLevelName;
    },
    syllabusText() {
      return this.selectedSyllabusObj
        ? this.subjects.length
          ? `No. materias (${this.subjects.length})`
          : 'El plan de estudios seleccionado no tiene materias'
        : '';
    },
  },
  watch: {},
  async created() {
    this.loading = true;
    this.group.institucion_educativa = this.institutionId;

    this.bkEntity = this.entity;
    this.bkReadonly = this.readonly;

    this.alertText = 'Cargando... Por favor, espera';
    this.alertType = 'info';
    this.showAlert = true;
    Object.assign(this.teacherPagination, this.pagination);
    this.setPaginationLimit(30);

    await this.fetchData();

    this.showAlert = false;
    this.loading = false;
  },
  methods: {
    setTabValue(val) {
      this.valueDeterminate = val;
    },
    getFullName: getFullName,
    async fetchData() {
      const { ok: okSchoolCycles, data: dataSchoolCycles } =
        await fetchSchoolCycles({
          institutionId: this.institutionId,
          systemStatus: true,
          limit: 1000,
        });
      const { ok: okSchoolLevels, data: dataSchoolLevels } =
        await fetchSchoolLevels({
          institutionId: this.institutionId,
          systemStatus: true,
          limit: 100,
        });
      // const { ok: okSyllabus, data: dataSyllabus } = await fetchSyllabus({
      //   institutionId: this.institutionId,
      //   systemStatus: true,
      //   limit: 2000,
      // });
      const { ok: okTypeEmployee, data: dataTypeEmployee } =
        await fetchTypesEmployee({
          dato: 'docente',
          institutionId: this.institutionId,
          systemStatus: true,
        });
      this.teacherType = okTypeEmployee
        ? dataTypeEmployee.length
          ? dataTypeEmployee[0]
          : null
        : null;
      const { ok: okEmployee, data: dataEmployee } = await fetchEmployee({
        institutionId: this.institutionId,
        typeEmployee: this.teacherType ? this.teacherType.id : null,
        systemStatus: true,
        limit: this.teacherPagination.limit,
      });
      // const { ok: okSubjects, data: dataSubjects } = await fetchSubjects({
      //   institutionId: this.institutionId,
      //   systemStatus: true,
      //   limit: 500,
      // });
      const { ok: okBranches, data: dataBranches } = await fetchGroupSucursals({
        institutionId: this.institutionId,
        systemStatus: true,
        limit: 30,
      });
      // const { ok: okStudent, data: dataStudent } = await fetchStudents({
      //   institutionId: this.institutionId,
      //   systemStatus: true,
      //   limit: 30,
      // });
      // const {ok: okClassroom, data: dataClassroom} = await fetchClassroom({
      //   institutionId: this.institutionId,
      //   systemStatus: true,
      //   limit: 30
      // })
      this.branches = okBranches ? dataBranches : [];
      this.cycles = okSchoolCycles ? dataSchoolCycles : [];
      this.levels = okSchoolLevels ? dataSchoolLevels : [];
      // this.syllabus = okSyllabus ? dataSyllabus : [];
      // this.subjects = okSubjects ? dataSubjects : [];
      this.teachers = okEmployee ? dataEmployee : [];
    },
    async setClassroom() {
      this.loading = true;
      const { ok: okClassroom, data: dataClassroom } = await fetchClassroom({
        institutionId: this.institutionId,
        sucursal: this.group.sucursal,
        systemStatus: true,
        limit: 500,
      });
      this.classrooms = okClassroom ? dataClassroom : [];
      this.loading = false;
    },
    async setSyllabus() {
      this.loading = true;
      const { ok: okSyllabus, data: dataSyllabus } = await fetchSyllabus({
        institutionId: this.institutionId,
        schoolCycleId: this.group.ciclo_escolar,
        schoolLevel: this.selectedSchoolLevelName,
        systemStatus: true,
        limit: 500,
      });
      this.syllabus = okSyllabus ? dataSyllabus : [];
      this.loading = false;
    },
    async setSubjects() {
      this.loading = true;
      if (this.selectedSyllabusObj) {
        const allSubjects = [
          ...this.selectedSyllabusObj.materias_curriculares,
          ...this.selectedSyllabusObj.materias_extracurriculares,
        ];
        this.subjects = allSubjects;
      } else {
        this.subjects = [];
      }
      this.loading = false;
    },
    async searchSubjects() {
      try {
        if (!this.loadingGroups) {
          this.loadingGroups = true;
          this.subjects = [];
          const { ok: okSubjects, data: dataSubjects } = await fetchSubjects({
            institutionId: this.institutionId,
            name: this.inputSubject,
            systemStatus: true,
            limit: 2000,
          });
          if (okSubjects) {
            this.subjects = dataSubjects;
          }
        }
      } catch (error) {
        console.log('Error al intentar obtener materias', error);
      } finally {
        this.loadingGroups = false;
      }
    },
    async searchEmployee() {
      try {
        if (!this.loadingEmployees) {
          this.loadingEmployees = true;
          this.teachers = [];
          if (this.inputTeacher && this.inputTeacher !== '') {
            const { ok, data } = await fetchEmployeeByName(
              this.inputTeacher,
              this.teacherPagination,
              true,
              this.institutionId,
              this.teacherType ? this.teacherType.id : null
            );
            // console.log('data fetchEmployeeByName', data.results);

            this.teachers = ok ? data.results : [];
            // console.log('this.teachers', this.teachers);
          } else {
            const { ok: okEmployee, data: dataEmployee } = await fetchEmployee({
              institutionId: this.institutionId,
              typeEmployee: this.teacherType ? this.teacherType.id : null,
              systemStatus: true,
              limit: this.teacherPagination.limit,
            });
            this.teachers = okEmployee ? dataEmployee : [];
          }
        }
      } catch (error) {
        console.log('Error al intentar obtener empleados', error);
      } finally {
        this.loadingEmployees = false;
      }
    },
    async getStudents() {
      if (this.assignStudents && this.group.nivel_educativo) {
        await this.searchStudent(1);
      }
    },
    async searchStudent(page = 1) {
      try {
        // console.log('searchStudent page', page);

        if (!this.loadingStudents) {
          this.loadingStudents = true;
          this.students = [];
          this.setPaginationPage(page);
          if (this.inputStudent && this.inputStudent !== '') {
            const { ok, data } = await fetchStudentByName(
              this.inputStudent,
              this.pagination,
              true,
              this.institutionId,
              this.selectedSchoolLevelName
            );
            if (ok) {
              this.students = data.results;
              this.setPaginationCount(data.results.length);
            } else {
              this.setPaginationCount(0);
            }
          } else {
            const {
              ok: okStudent,
              data: dataStudent,
              count: countStudent,
            } = await fetchStudents({
              institutionId: this.institutionId,
              systemStatus: true,
              schoolLevelId: this.group.nivel_educativo,
              noGroup: true,
              limit: this.pagination.limit,
              offset: this.pagination.offset,
            });
            this.students = okStudent ? dataStudent : [];
            this.setPaginationCount(countStudent);
          }
        }
      } catch (error) {
        console.log('Error al intentar obtener alumnos', error);
      } finally {
        this.loadingStudents = false;
      }
    },
    addStudent(item) {
      const detailItem = { ...item, ...this.studentDetail };
      this.selectedStudents.push(detailItem);
    },
    removeStudent(item) {
      this.selectedStudents = this.selectedStudents.filter(
        (sStudent) => sStudent.id !== item.id
      );
    },
    addSubjectTeacher() {
      const item = {
        teacher: this.selectedTeacherObj,
        subjects: this.selectedSubjectsObj,
      };
      this.subjectTeacherData.push(item);
      this.clearSelection();
    },
    clearSelection() {
      this.selectedTeacher = null;
      this.selectedSubjects = [];
    },
    async createGroup() {
      try {
        this.alertText = 'Creando grupo';
        this.group.profesores = this.subjectTeacherData.length
          ? this.subjectTeacherData.map((std) => std.teacher.id)
          : [];
        this.group.materia_profesor = [...this.createdSubjectsTeacher];

        console.log('createGroup group', this.group);

        const { ok, data, message } = await postGroup(this.group);
        if (ok) {
          this.alertText = 'Grupo creado exitosamente';
          this.groupId = data.id;
        } else {
          this.errors.push('No se pudo crear grupo. ' + message);
        }
      } catch (error) {
        this.errors.push('Error al intentar crear grupo. ' + error);
      }
    },
    async assignSubjectsTeachers() {
      try {
        for (const item of this.subjectTeacherData) {
          const { ok, createdSubjectsTeacher, errors } =
            await createSubjectTeacher(
              item.teacher.id,
              item.subjects,
              this.institutionId
            );
          if (ok) {
            this.createdSubjectsTeacher.push(...createdSubjectsTeacher);
            if (errors.length) {
              this.warnings.push(...errors);
            }
          } else {
            this.warnings.push(
              'No se pudo asignar materias a profesor ' +
                item.teacher.datos_personales
            );
          }
        }
      } catch (error) {
        this.warnings.push(
          'Error al intentar asignar materias profesor. ' + error
        );
      }
    },
    async assignStudentsToGroup() {
      try {
        const selectedStudentIds = this.selectedStudents.map((ss) => ss.id);
        const { ok, data, message } = await postAssignStudentsToGroup(
          this.groupId,
          this.group.plan_estudios,
          selectedStudentIds
        );
        console.log('assignStudentsToGroup data', data);

        if (ok) {
          this.alertText = 'Alumnos asignados exitosamente';
        } else {
          this.warnings.push(
            'Error al intentar asignar alumnos a grupo. ' + message
          );
        }
      } catch (error) {
        this.warnings.push(
          'Error al intentar asignar alumnos a grupo. ' + error
        );
      }
    },
    async save() {
      this.loading = true;
      this.alertColor = 'info';
      this.alertText = 'Cargando...';
      this.showAlert = true;
      if (this.isNewMode) {
        if (this.assignTeacher) {
          await this.assignSubjectsTeachers();
        }
        await this.createGroup();
        if (this.assignStudents && this.groupId) {
          await this.assignStudentsToGroup();
        }
      }
      this.completeAlert();
    },
    saveImage(fileObj) {
      this.groupImage = fileObj;
    },
    clearImage() {
      this.groupImage = null;
    },
    completeAlert() {
      this.loading = false;

      if (this.errors.length) {
        this.alertType = 'error';
        this.alertColor = 'error';
        this.alertText = this.errors.join(', ');
      } else {
        this.alertType = this.successAlertType;
        this.alertColor = 'success';
        this.alertText = this.successAlertText;
      }
    },
    // insufficientPermissionAlert() {
    //   this.alertType = 'info';
    //   this.alertText = insufficientPermissionsMessage();
    //   this.alertColor = 'warning';
    //   this.loading = false;
    //   this.showAlert = true;
    // },
    cancel() {
      this.$router.push({ name: this.routerName });
    },
    actionAlertBtn1() {
      if (this.alertType === 'success' || this.alertType === 'info') {
        this.returnToTable();
      } else {
        this.closeAlert();
      }
    },
    continueAdding() {
      this.clean();
      this.closeAlert();
      this.setTabValue(this.tabs[0].value);
    },
    returnToTable() {
      this.$router.replace({ name: this.routerName });
    },
    closeAlert() {
      this.errors = [];
      this.showAlert = false;
    },
    clean() {
      this.group = {};
      this.selectedStudents = [];
    },
    removeChip(id) {
      this.subjects = this.subjects.filter((subject) => subject !== id);
    },
    removeSubjectChip(mainIndex, subjectId) {
      console.log('removeSubjectChip', mainIndex, subjectId);

      this.subjectTeacherData[mainIndex].subjects = this.subjectTeacherData[
        mainIndex
      ].subjects.filter((s) => s.id !== subjectId);
      if (!this.subjectTeacherData[mainIndex].subjects.length) {
        const teacherId = this.subjectTeacherData[mainIndex].teacher.id;
        this.subjectTeacherData = this.subjectTeacherData.filter(
          (item) => item.teacher.id !== teacherId
        );
      }
    },
  },
};
